import axios from "axios";
import dotenv from "react-dotenv"

const instance = axios.create({
  baseURL: dotenv.base_url,
});

export default instance;
